import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function ArchitectureSection() {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("mpc-architecture-svg")
  return (
    <Container section>
      <Heading label="Architecture" title="How it works" decoration="border" />
      <Image className="mt-8 w-full" src={illustration} />
    </Container>
  )
}

export default ArchitectureSection
